import React from 'react'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import { ModelWithForm } from '@morningtrain/react-resources'
import AdminPage from 'pages/app/AdminPage'
import EmploymentTypeFormFields from 'pages/app/settings/employment_types/partials/EmploymentTypeFormFields'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import { ButtonWrap, SquareButton } from 'ui'
import * as Icons from 'ui/icons'

export default function EmploymentTypesEdit (props) {
  return (
    <AdminPage>
      <Translator namespace='settings.employment_types'>
        <ModelWithForm resourceName='employments.employment_type'>
          <UI.PageHeader title={<TranslatedTitle name='titles.edit' />}>
            <UI.ButtonWrap>
              <DeleteModelOnClick pipes={<NavigateOnPipe route='app.settings.employment_types.index' />}>
                <SquareButton color='btn-red' big>
                  <Icons.Trash className='w-4 h-4' />
                </SquareButton>
              </DeleteModelOnClick>
              <UI.Button type='submit'>
                <Translation name='actions.submit' />
              </UI.Button>
            </UI.ButtonWrap>
          </UI.PageHeader>
          <EmploymentTypeFormFields />
        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
